import atlasApi from '..'

const balancePrefix = '/brands/pay'

const getBalance = async (email) => {
  try {
    const response = await atlasApi
      .post(`${balancePrefix}/get-balance`, {
        email
      })
      .catch((err) => err)

    if (response.status === 200) {
      return [200, response]
    }
  } catch (error) {
    return [error.response.status, error]
  }
}

export { getBalance }
